<template>
  <div id="wrapper">
    <div id="content-wrapper" class="page">
      <div class="container-fluid">
        <a href="#" @click.prevent="goBack">
          <i class="fas fa-arrow-left"></i> Quay lại
        </a>
        <b-card class="mt-3">
          <b-form autocomplete="off" @submit.prevent="storeItem()">
            <b-row>
              <b-col cols = "12">
                <b>Phân công việc</b>
                <b-link
                  class="ml-4"
                  href="#"
                  v-b-tooltip.hover
                  title="Công việc quan trọng"
                  @click="changePriority"
                >
                  <i
                    class="fas fa-flag"
                    v-bind:class="{ 'text-muted': item.important == false, 'text-danger': item.important == true }"
                  ></i>
                </b-link>

                <b-link
                class="ml-4"
                href="#"
                v-b-tooltip.hover
                title="Công việc hàng tháng"
                @click="changeLabel"
                >
                  <i
                    class="fas fa-calendar-alt"
                    v-bind:class="{ 'text-muted': item.label == 0, 'text-info': item.label == 1 }"
                  >
                  </i>
                </b-link>
                <div class="float-right">
                  <button class="btn btn-primary mb-3" type="submit">Lưu</button>
                </div>
              </b-col>
              <!-- <b-col cols="1">

              </b-col> -->
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <template v-slot:label>
                    Tên công việc
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input v-model="item.name"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group>
                  <template v-slot:label>
                    Người thực hiện
                    <span class="text-danger">*</span>
                  </template>
                  <multiselect
                    v-model="item.employee"
                    placeholder
                    track-by="id"
                    label="hovaten"
                    selectedLabel="Đang chọn"
                    select-label="Enter để chọn"
                    deselectLabel="Enter để xóa"
                    :searchable="true"
                    :options="employees"
                    :taggable="true"
                  ></multiselect>
                </b-form-group>
              </b-col>

              <!-- REMOVE BECAUSE WE DONT NEEED IT ANYMORE BUT MAYBE WE STILL NEED THIS SOME DAY
              <b-col>
                <b-form-group>
                  <template v-slot:label>
                    Người liên quan
                  </template>
                  <multiselect
                    v-model="item.employees"
                    placeholder
                    track-by="id"
                    label="hovaten"
                    selectedLabel="Đang chọn"
                    select-label="Enter để chọn"
                    deselectLabel="Enter để xóa"
                    :searchable="true"
                    :multiple="true"
                    :options="employees"
                  ></multiselect>
                </b-form-group>
              </b-col> -->
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group>
                    <template v-slot:label>
                        Ngày bắt đầu
                        <span class="text-danger">*</span>
                    </template>
                  <vue-datepicker-local
                    v-model="item.start"
                    :local="local"
                    clearable
                    format="DD/MM/YYYY"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Ngày kết thúc">
                  <vue-datepicker-local
                    v-model="item.end"
                    :local="local"
                    clearable
                    format="DD/MM/YYYY"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Nội dung">
                  <b-form-textarea v-model="item.content" rows="4" max-rows="10" no-auto-shrinK></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Đính kèm">
                  <b-form-file
                    v-model="item.attachs"
                    placeholder="Nhấn vào đây để thêm tệp đính kèm"
                    browse-text="..."
                    multiple
                  ></b-form-file>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  name: "Task",
  components: {
    VueDatepickerLocal,
    Multiselect,
  },
  data() {
    return {
      item: {
        important: false,
        employee: null,
        employees: null,
        start: "",
        end: "",
        name: null,
        content: "",
        attachs: [],
        label: 0,
      },
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
      tepattachsfile: [],
      khachhang_selected: null,
      isLoading: false,
      employees: [],
    };
  },

  beforeRouteEnter(to, from, next) {
    axios.get(`/api/employee/getallbytask`).then((res) => {
      next((vm) => vm.initData(res.data));
      // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    initData(employees) {
      if (employees) {
        this.employees = employees;
      }
    },
    changePriority() {
      if (this.item.important == false) this.item.important = true;
      else this.item.important = false;
    },
    changeLabel() {
      if (this.item.label == 0) this.item.label = 1;
      else this.item.label = 0;
    },
    isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    },

    storeItem() {
      var startDate = new Date( this.item.start);
      var endDate = new Date(this.item.end); //Neu bang null thi endDate = 1970 co gia tri
      if (!this.isValidDate(startDate) || this.item.start == null)
      {
        startDate = null;
        this.item.start = null;
      }
      else
      {
        startDate.setHours(0,0,0);
      }

      if (!this.isValidDate(endDate) || this.item.end == null)
      {

        endDate = null;
        this.item.end = null;
      }
      else
      {
        //@Thanh Set hour cuoi cung cua ngay, mai mot chinh ngay sau o day
        endDate.setHours(23,59,0);
      }
      // Dien cac thong tin
      if (!(this.item.name && this.item.name.length)) {
        this.$toast.error("Vui lòng nhập tên công việc", "Lỗi", {timeout: 2000,});
      }
      else if (!this.item.employee){
         this.$toast.error("Vui lòng chọn người thực hiện", "Lỗi", {timeout: 2000,});
      }
      else if (!this.isValidDate(startDate)){
        this.$toast.error("Vui lòng chọn NGÀY BẮT ĐẦU", "Lỗi", {timeout: 2000,});
      }
      else if (this.isValidDate(endDate) && (startDate >= endDate))
      {
          this.$toast.error("Vui lòng chọn NGÀY KẾT THÚC lớn hơn NGÀY BẮT ĐẦU", "Lỗi", {timeout: 2000,});
      }
      else {
        this.item.start = startDate;
        this.item.end = endDate;

        const formData = new FormData();
        formData.append("important", this.item.important);
        formData.append("label", this.item.label);
        formData.append("employee", this.item.employee.id);
        let i = 0;
        // formData.append("start",this.item.start == "" ? "" : new Date(this.item.start).toUTCString());
        // formData.append("end",this.item.end == "" ? "" : new Date(this.item.end).toUTCString());
        formData.append("start",this.item.start == null ? "" : new Date(this.item.start).toUTCString());
        formData.append("end",this.item.end == null ? "" : new Date(this.item.end).toUTCString());
        formData.append("name",this.item.name);
        formData.append("content",this.item.content);
        for (i = 0; i < this.item.attachs.length; i++) {
          formData.append("attachs", this.item.attachs[i]);
        }
        axios
          .post("/api/task", formData)
          .then((res) => {
            this.$toast.success("Lưu thành công!", "Thành công", {
              timeout: 3000,
            });
            this.goBack();
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
